import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/category/blood", label: "热血" },
  { to: "/category/suspense", label: "悬疑" },
  { to: "/category/healing", label: "治愈" },
  { to: "/category/romance", label: "恋爱" },
  { to: "/category/scifi", label: "科幻" },
  { to: "/category/comedy", label: "搞笑" },
];

export default function Navbar() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);

  const isActive = (to: string) => {
    if (to === "/") return location.pathname === "/";
    return location.pathname.startsWith(to);
  };

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/70 bg-background-50/95 backdrop-blur">
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5" aria-label="漫天堂首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-book-open-fill text-lg"></i>
          </span>
          <span className="font-heading text-xl font-extrabold tracking-wide text-foreground-950">
            漫天堂
          </span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => {
            const active = isActive(link.to);
            return (
              <Link
                key={link.to}
                to={link.to}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  active
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            to="/about"
            className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
              isActive("/about")
                ? "bg-primary-500 text-background-50"
                : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 hover:bg-background-100 md:hidden"
          aria-label="打开菜单"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </nav>

      {/* Mobile dropdown */}
      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-wrap gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setOpen(false)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  isActive(link.to)
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-700 hover:text-foreground-950"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              onClick={() => setOpen(false)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                isActive("/about")
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:text-foreground-950"
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}